<script setup>
import { inject, ref } from 'vue'
import { useClipboard } from '@vueuse/core'

const message = inject('message')
const close = inject('close')

const source = ref(message.text)
const { copy, copied, isSupported } = useClipboard({ source })

async function doCopy () {
  copy()
  await new Promise((resolve) => setTimeout(resolve, 500))
  close()
}
</script>

<template>
  <button
    v-if="isSupported"
    role="menuitem"
    class="flex items-center gap-2.5 px-1 py-3 w-full text-left"
    @click="doCopy">
    <InlineSvg :src="require('@/assets/fontawesome/regular/copy.svg')" class="w-4 h-4 shrink-0"/>
    <span v-if="!copied">{{ $t('common.copy') }}</span>

    <span v-else>{{ $t('common.copied') }}</span>
  </button>
</template>